import { createBrowserHistory, LocationDescriptor } from 'history';

// Modify the browser history object to add a custom replace() method
// in order to keep track of the previous location stack (current history does not save the history stack & push enables the browsers back button)
export const customHistory = (() => {
  const browserHistory = createBrowserHistory();

  const historyStack: LocationDescriptor[] = [];

  const getCurrentLocation = () => ({ ...window.location });

  const replace: typeof browserHistory.replace = (location, state) => {
    // Push the current location to the stack
    historyStack.push(getCurrentLocation());

    return browserHistory.replace(location, state);
  };

  const goBack: typeof browserHistory.goBack = () => {
    if (historyStack.length < 1) {
      throw new Error('History stack is empty');
    }

    // Retrieve the last location from the stack and replace the current location with it
    return browserHistory.replace(historyStack.pop());
  };

  return { ...browserHistory, replace, goBack };
})();
